import { defineMessages } from "react-intl";

export const orderGrantedRefundsMessages = defineMessages({
  grantedRefunds: {
    defaultMessage: "Granted refunds",
    id: "OAcl78",
    description: "order, granted refunds card, title",
  },
  unsettled: {
    defaultMessage: "Unsettled {money}",
    id: "7t+oJp",
    description: "orde, granted refunds card, unsettled amount",
  },
});
